// =============================================================================
// SCROLL REVEAL — Lightweight AOS-like animation
// =============================================================================

export function initScrollReveal() {
  const elements = document.querySelectorAll('[data-aos]');
  if (!elements.length) return;

  // Check prefers-reduced-motion
  const prefersReduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  if (prefersReduced) {
    // Skip animations, show all immediately
    elements.forEach(el => el.classList.add('aos-animate'));
    return;
  }

  // Set initial states
  elements.forEach(el => {
    const animation = el.getAttribute('data-aos');
    const delay = el.getAttribute('data-aos-delay') || 0;
    el.style.transitionDelay = `${delay}ms`;
    el.style.opacity = '0';

    if (animation === 'fade-up') {
      el.style.transform = 'translateY(28px)';
    } else if (animation === 'fade-right') {
      el.style.transform = 'translateX(-28px)';
    } else if (animation === 'fade-left') {
      el.style.transform = 'translateX(28px)';
    }

    el.style.transition = `opacity 0.6s ease ${delay}ms, transform 0.6s ease ${delay}ms`;
  });

  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          const el = entry.target;
          el.style.opacity = '1';
          el.style.transform = 'none';
          observer.unobserve(el);
        }
      });
    },
    {
      threshold: 0.12,
      rootMargin: '0px 0px -40px 0px',
    }
  );

  elements.forEach(el => observer.observe(el));
}
